import {Breadcrumb, HeaderTitle, Modal, ProgressIndicator} from '@/components/atoms'
import {SaveCancelFooter} from '@/components/molecules'
import {Step} from '@/containers/Promotions/components/PromotionSteps'
import {usePromotion} from '@/context/Promotion/PromotionContext'
import {useFeatureFlagLanguages} from '@/hooks/useFeatureFlagLanguages'
import {selectIsIndia} from '@/store/slices/countryCodeSlice'
import {PromotionStep} from '@/types/promotion'
import {MODAL_TYPE} from '@/utils/constants/globalStyle'
import {Header} from '@/utils/constants/header'
import {ROUTES} from '@/utils/constants/routesConstants'
import {getIsNextDisabled} from '@/utils/promotions/promotions'
import {useState} from 'react'
import {useSelector} from 'react-redux'
import {useNavigate, useLocation} from 'react-router-dom'

const breadcrumbUISchema = [
  {
    href: '/',
    label: '',
  },
  {
    href: ROUTES.SELECT_PROMOTION_TYPE,
    label: 'Promotions',
  },
  {
    href: ROUTES.CREATE_PROMOTION,
    label: 'Create Promotion',
  },
]

const ProgressLevelSteps = [{title: 'Setup'}, {title: 'Display'}, {title: 'Attributes'}, {title: 'Review'}]

const CreatePromotion = () => {
  const {
    promotion,
    handleDraft,
    currentStep,
    setCurrentStep,
    handleUpdatePromotion,
    promotionConfig,
    cleanupBannerImage, // Add this
  } = usePromotion()
  const navigate = useNavigate()
  const languages = useFeatureFlagLanguages()
  const isReview = currentStep === PromotionStep.REVIEW
  const [showCancelModal, setShowCancelModal] = useState(false)
  const [isDraftLoadng, setIsDraftLoading] = useState(false)
  const location = useLocation()
  const {isDuplicating} = location.state || {}
  const isSaveDraftDisabled = promotion?.status?.toUpperCase() === 'PUBLISHED' && !isDuplicating
  const handleNextAction = async () => {
    if (currentStep === PromotionStep.REVIEW) {
      handleUpdatePromotion({isCreating: true})
    } else if (currentStep === PromotionStep.SETUP && !promotion.id) {
      // We are doing this so we get the ID of the promotion, which is requried for image uplaod.
      try {
        setIsDraftLoading(true)
        await handleDraft({isSavingForImageUpload: true})
        setCurrentStep(currentStep + 1)
      } catch {
        // Draft save failed, don't advance the step
      } finally {
        setIsDraftLoading(false)
      }
    } else {
      setCurrentStep(currentStep + 1)
    }
  }

  const isIndia = useSelector(selectIsIndia)

  const handleCancel = async () => {
    // If we're on the display step, cleanup any image changes
    if (currentStep === PromotionStep.DISPLAY) {
      await cleanupBannerImage()
    }
    navigate(ROUTES.PROMOTIONS_LIST)
  }
  return (
    <div className="flex flex-col gap-4">
      <Breadcrumb
        uiSchema={{
          isDark: true,
          breadcrumbs: breadcrumbUISchema,
        }}
        id={'promotion-breadcrumb'}
      />
      <HeaderTitle title={'Create Promotion'} headingLevel={Header.PageHeader} className="$font-heading-h3-bold" />
      <ProgressIndicator
        currentStep={currentStep}
        steps={4}
        titles={ProgressLevelSteps}
        isDark={false}
        className="p-6"
      />

      <Step currentStep={currentStep} finalResult={promotion} setCurrentStep={setCurrentStep} />

      {showCancelModal && (
        <Modal
          type={MODAL_TYPE.SMALL}
          showModal={showCancelModal}
          onCloseModal={() => setShowCancelModal(false)}
          title="Are you sure you want to cancel?"
          text={'The changes will not be saved.'}
          showPrimaryButton={true}
          primaryButtonText="Yes"
          onClickPrimaryButton={handleCancel}
          showSecondaryButton={true}
          secondaryButtonText="No"
          onClickSecondaryButton={() => setShowCancelModal(false)}
          footerProps={{
            size: 'medium',
            type: 'primary',
          }}
          isDark={true}
        />
      )}

      <SaveCancelFooter
        handleCancel={() => setShowCancelModal(true)}
        draftAction={handleDraft}
        nextAction={handleNextAction}
        isReview={isReview}
        FormError={getIsNextDisabled(currentStep, promotion, languages, promotionConfig, isIndia)}
        isLoading={isDraftLoadng}
        isSaveDraftDisabled={isSaveDraftDisabled}
      />
    </div>
  )
}

export default CreatePromotion
